/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessage.defs.js'
export * as $defs from './sendMessage.defs.js'
